import React, { useState } from "react"
import Button from "../material/button/Button"
import PageHeader from "../pageheader/PageHeader"
import ListDataPatient from "./ListDataPatient"
import MenuDoctor from "./navDoctor/MenuDoctor"
import StatusDataPatient from "./StatusDataPatient"

import styles from './ListDataPatient.module.css'

export default function HistoryDataAccessRights() {
    const [toggle, setToggle] = useState('listDataPatient')

    return (
      <div class="flex w-full bg-[#ffffff] pb-[30px]">
        <div className={styles.blockContent}>
          <div
            className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
          >
            ประวัติการขอเข้าถึงข้อมูลทั้งหมด
          </div>
          <StatusDataPatient />
        </div>
      </div>
    );
}

